import React, { useState, useEffect, useRef } from "react";
import { IIconProps } from '@fluentui/react';
import styles from "./FileUploader.module.css";
import { useUpload } from "../../context/UploadProvider/useUpload";
import FileSwith from "./FileSwith/FileSwith";
import { useParams } from "react-router-dom";
import { ContractSizeByOrgName, GetOneOrganization, GetOrganizationAdminUsers } from "../../services/OrganizationServices";
import { AdminUserVO, IReturnAllSizes, Organization, User } from "../../model/OrganizationModel";
import { PaywallModal } from "../../components/PaywallModal/PaywallModal";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { MaxStorageIcon } from "../../assets/icons/MaxStorageIcon";
import { useTranslation } from "react-i18next";import { UploadFile } from "../../assets/icons/upload";
import { IconButton } from "@mui/material";
import { Add, Close, FileUpload, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import axios, { CancelTokenSource } from "axios";
import { countFilesAndFolders } from "../../utils/CountFilesUpload";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { TemporaryFileIcon } from "../../assets/icons/TemporaryFileIcon";
import { PaywallInformation } from "../../model/PaywallModel";

export const FileUploader: React.FC = () => {

  const upload = useUpload();
  const [lastIsDone, setLastIsDone] = useState<number | undefined>(undefined);
  const [childrenIdUpload, setChildrenIdUpload] = useState<number | undefined>(undefined);
  const { t } = useTranslation();  
  const [totalItensInUpload, setTotalItensInUpload] = useState<number | undefined>(undefined);
  const [totalItensCompleted, setTotalItensCompleted] = useState<number>(0);
  const diffTotalUpload = totalItensInUpload! - totalItensCompleted;
  const [cancelUploadAll, setCancelUploadAll] = useState<boolean>(false);
  const [showModalCancelUploadAll, setShowModalCancelUploadAll] = useState<boolean>(false);
  const [paywallInfo, setPaywallInfo] = useState<PaywallInformation>();
  const [openPaywallModal, setOpenPaywallModal] = useState<boolean>(false);
  const [adminUserData, setAdminUserData] = useState<AdminUserVO | undefined>(undefined);

  const ascClick = () => {
    upload.setShowEx(true)
  };

  const descClick = () => {
    upload.setShowEx(false)
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      let doIt = true;
      let i: number = 0;
      for (i = 0; i < myRefs.current.length; i++) {
        if (myRefs.current[i].fileIsDone() == false) {
          doIt = false;
        }
      }

      if (doIt) {
        setTotalItensCompleted(0)
        upload.clear();
        if (upload.fileList == undefined || (upload.fileList != undefined && upload.fileList.length == 0)) {
          setLastIsDone(undefined);
        }
      }
      else {
        console.log("nao limpo");
      }
    }, 10000)

    return () => clearTimeout(timer)
  }, [lastIsDone, upload.fileList?.length])

  const myRefs = useRef<any[]>([]);

  useEffect(() => {
    if (childrenIdUpload == undefined && upload.fileList != undefined && upload.fileList.length > 0) {
      setChildrenIdUpload(0);

      myRefs.current = myRefs.current.slice(0, upload.fileList.length);
    }
    else {
      setChildrenIdUpload(undefined);
      myRefs.current = myRefs.current.slice(0, 0);
    }
    if (upload.fileList?.length == 1 && upload.fileList[0].fileWorkspace != undefined)
      setTotalItensCompleted(0)
    setTotalItensInUpload(countFilesAndFolders(upload.fileList!))
    setCancelUploadAll(false);
  }, [upload.fileList]);

  function verifyCloseUpload() {
    if (diffTotalUpload > 0) {
      setShowModalCancelUploadAll(true);
    } else {
      closeUpload();
    }
  }

  function closeUpload() {
    setCancelUploadAll(true);
    setTimeout(() => {
      upload.clear();
      setTotalItensCompleted(0);
      setLastIsDone(undefined);
      if (showModalCancelUploadAll) {
        setShowModalCancelUploadAll(false)
      }
    }, 1000)
  }



  return (
    <div
      className={
        (upload.fileList != undefined && upload.fileList.filter(x => x != undefined).length > 0) ? `${styles.fileUploader} ${styles.visible}` : `${styles.invisible}`
      }
      style={{
        maxHeight: "100%",
        color: "#2D2D2D",
        backgroundColor: "#FFFFFF",
        padding: 0,
        border: "1px solid #D5D5D5",
        borderRadius: "4px 4px 0 0",
        width: "280px",
        boxShadow: "1px 1px 5px"
      }}
    >
      <div style={{
        padding: "12px",
      }}>
        <div style={{

          display: "flex",
          alignItems: "center",
          justifyContent: "space-between"
        }}>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "2px"
          }}>
            <UploadFile color="#2D2D2D" />
            {t("FileUploader.UploadOfFiles")}
          </div>
          <div>

            {upload.show ?
              <IconButton onClick={descClick}> <KeyboardArrowDown /> </IconButton> :
              <IconButton onClick={ascClick}> <KeyboardArrowUp /> </IconButton>
            }
            {
              <IconButton onClick={verifyCloseUpload} >
                <Close />
              </IconButton>
            }
          </div>
        </div>
        <div>
          <p style={{ font: "normal normal normal 12px/18px Segoe UI", color: "#969696", marginLeft: "5px" }}>{`${diffTotalUpload > 0? diffTotalUpload : 0} ${t("FileUploader.Of")} ${totalItensInUpload} ${t("FileUploader.FilesInProgress")}`}</p>
        </div>
      </div>
      <div
        className={upload.show ? styles.visible : styles.invisible}
        style={{
          overflowY: "scroll",
          width: "100%",
          maxHeight: "300px",
          borderTop: "1px solid rgb(213, 213, 213)",

        }}
      >
        {upload.fileList != undefined && (
          upload.fileList.map((file, index) => (
            <FileSwith
              ref={el => myRefs.current[index] = el}
              file={file}
              key={index}
              index={index}
              setLastIsDone={setLastIsDone}
              indexToUpload={childrenIdUpload}
              uploadCompleted={totalItensCompleted}
              setUploadCompleted={setTotalItensCompleted}
              cancelUploadAll={cancelUploadAll} 
              setAdminUserData={setAdminUserData}
              setPaywallInfo={setPaywallInfo}
              paywallInfo={paywallInfo!}
              setOpenPaywallModal={setOpenPaywallModal}
              closeUpload={closeUpload}
            />
          ))
        )}
      </div>
      <KeyDriveDialog
        keyDriveDialogButtons={{
          leftButtonText: t("FileUploader.TextButtonReject"),
          rightButtonText: t("FileUploader.TextButtonAccept"),
          rightButtonMethod: closeUpload,
          leftButtonMethod: () => { setShowModalCancelUploadAll(false) }
        }}
        keyDriveDialogContent={{
          dialogTitle: t("FileUploader.TitleModalCloseUpload"),
          dialogContent: t("FileUploader.SubtitleModalCloseUpload"),
          dialogIcon: <TemporaryFileIcon />,
          openDialog: showModalCancelUploadAll,
          handleTogglDialog: () => { }
        }} />
        <PaywallModal
          open={openPaywallModal}
          setOpen={setOpenPaywallModal}
          icon={<MaxStorageIcon />}
          isStorageAdmin={adminUserData?.userLoggedIsNotAdmin === false}
          subtitleStart=""
          subtitleBold=""
          subtitleEnd=""
          paywallContent={paywallInfo?.paywallContent!}
      />
    </div>
  );
};
